import Column from '@app/components/layout/Column'
import { ContentSections } from '@app/components/blocks/contentSection/ContentSection'
import useMediaQuery from '@app/util/useMediaQuery'
import { BusinessProfile } from '@schema/businessProfile'

export const Overview = ({
  businessProfile,
}: {
  businessProfile: BusinessProfile
}) => {
  const isMobile = useMediaQuery()
  const largerGap = isMobile ? '2rem' : '3.5rem'

  return (
    <Column gap={largerGap}>
      <ContentSections sections={businessProfile.contentBlocks || []} />
    </Column>
  )
}
